module.exports = __webpack_public_path__ + "img/Hahn.e24896cc.png";